import styled from "@emotion/styled";
import { Flex } from "./Layout";
import { boxShadow, color } from "./theme";

export const BoxWithShadow = styled(Flex)`
  background-color: ${color.N0};
  border-radius: 8px;
  box-shadow: ${boxShadow.normal};
`;
